import { Menu, ActionIcon, useMantineTheme } from '@mantine/core';

import { useState } from 'react';

import { ThreeDotsHorizontal, Trash } from '../../icons';

interface Props {
  onClickDelete: () => void
  disabled?: boolean
}

const SyncConfigDropdown: React.FC<Props> = (props: Props) => {
  const { onClickDelete, disabled } = props;
  const [opened, setOpened] = useState(false);
  const { colors } = useMantineTheme();
  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
    >
      <Menu.Target>
        <ActionIcon
          disabled={disabled}
          onClick={(event) => { setOpened((o) => !o); event.stopPropagation(); }}
          c={colors.gray[5]}
          variant='subtle'
        >
          <ThreeDotsHorizontal />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          c={colors.red[5]}
          leftSection={<Trash />}
          onClick={() => { onClickDelete(); setOpened(false); }}
        >
          Remove this location
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default SyncConfigDropdown;
